import {clsx} from 'external/clsx'
import {FC} from 'external/react'

type LoaderProps = {
	loading: boolean
}

const Loader: FC<LoaderProps> = props => {
	const {loading} = props
	return <div className={clsx('loader', {'d-none': !loading})} />
}

export {Loader as default}
